var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from "styled-components";
import { forBp, NSStyles } from "@gw/theming";
export var CoverImage = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: #d0dbe1;\n  background-image: ", ";\n  background-size: cover;\n  background-position: center;\n  height: 150px;\n  width: 100%;\n\n  ", "\n"], ["\n  background-color: #d0dbe1;\n  background-image: ", ";\n  background-size: cover;\n  background-position: center;\n  height: 150px;\n  width: 100%;\n\n  ",
    "\n"])), function (_a) {
    var coverImg = _a.coverImg;
    return "url(" + coverImg + ")";
}, forBp(NSStyles.TBreakPoint.mobile_lg, css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      height: 250px;\n    "], ["\n      height: 250px;\n    "])))));
var templateObject_1, templateObject_2;
//# sourceMappingURL=CoverImage.js.map